<template>
    <div class="w-100">
        <div class="fixedtop" ref='fixedbox' v-if="flashDome&&$route.fullPath=='/'">
            <imgexhibite @showheadle="showheadle" ref='fixedbox' :maskimg='maskimg' v-if="flashDome"></imgexhibite>
        </div>
        <router-view />
    </div>

</template>
<script>
import imgexhibite from "./components/imgexhibite.vue";
export default {
    components:{
        imgexhibite
    },
    data(){
        return{
            flashDome:false,
            maskimg:''
        }
    },
    mounted(){
        this.getimgurl()
        this.saveDict()

    },
    methods:{
        getimgurl() {
			var that = this;
            //  this.maskimg= require("@/assets/img/swiper1.png");
            //  this.flashDome=true;//测试
			this.$get("/web/home/queryAdvertising").then(res => {
				console.log('imgUrl',res)
                if(res.result.boardHide){
                    this.maskimg= res.result.boardImg?this.$imgUrl+res.result.boardImg:''

                    if(window.name === ""){//首次被加载
                        console.log('首次被加载')
                        window.name = "refresh";
                        if(this.maskimg&&(res.result.boardHide=='true')){
                            this.flashDome=true;
                            this.timer=setTimeout(()=>{
                                if(this.$refs.fixedbox){
                                    this.$refs.fixedbox.setImgH(0)
                                }

                                setTimeout(()=>{
                                    this.showheadle()
                                },1000)

                                // this.$refs.fixedbox.setAttribute("class", "bounceOutUp")
                            },6000)
                        }
                    }else{//刷新
                        console.log('刷新')
                    }

                }


			});
		},
        saveDict(){
            var arr1=[];
            var arr2=[];
            this.$get('/sys/dict/getDictItems/study_type').then(res => {
                arr1 = res.result;
                if (arr1) {
                    localStorage.setItem('dictStudy', arr1 ? JSON.stringify(arr1) : [])
                }

            })
            this.$get('/sys/dict/getDictItems/file_type').then(res => {
                arr2 = res.result;
                if (arr2) {
                    localStorage.setItem('dictFile', arr2 ? JSON.stringify(arr2) : [])
                }
            })
        },
        showheadle(){
            console.log('close')
            this.flashDome=false;
        }
    }
}
</script>
<style scoped>
.w-100{
    width: 100%;
}
.fixedtop{
    position: relative;
    /* position: fixed; */
    top: 0;
    z-index: 20;
    width: 100%;
}
</style>
